import FetchClient, { type ApiResponse } from "./FetchClient";

export interface ProductRecommendation {
  productKey: string;
  retailer: string;
  retailerName: string;
  name: string;
  image: string;
  currentPrice: number;
  msrp: number;
  discountPercent: number;
  category: string;
  matchType: "exact" | "similar" | "related";
  matchScore: number;
  reason: string;
  lastUpdated: number;
}

export interface ProductRecommendationsResponse {
  items: ProductRecommendation[];
  warming: boolean;
  generatedAt: number;
}

export interface ProductRecommendationsRequest {
  sku: string;
  storeId: string;
  retailer: string;
  limit?: number;
}

export async function getProductRecommendations(
  request: ProductRecommendationsRequest
): Promise<ProductRecommendationsResponse> {
  const params = new URLSearchParams({
    sku: request.sku,
    storeId: request.storeId,
    retailer: request.retailer,
    limit: String(request.limit ?? 6),
  });
  const response = await FetchClient.get<ApiResponse<ProductRecommendationsResponse>>(
    `/product-recommendations?${params.toString()}`
  );
  return response.data;
}

export function getProductRecommendationsQueryKey(
  request: ProductRecommendationsRequest
): readonly unknown[] {
  return [
    "product-recommendations",
    request.retailer,
    request.storeId,
    request.sku,
    request.limit ?? 6,
  ];
}
